import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatStepper, MatStep, MatStepLabel } from '@angular/material/stepper';
import { XeroService } from '../../../shared/services/xero.service';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';
import { TaxMappingsComponent } from './tax-mappings/tax-mappings.component';
import { AccountMappingsComponent } from './account-mappings/account-mappings.component';

@Component({
    selector: 'account-tax-dialog',
    templateUrl: './account-tax-dialog.component.html',
    providers: [XeroService],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatStepper, MatStep, MatStepLabel, AccountMappingsComponent, TaxMappingsComponent, MatDialogActions, FlexModule, MatButton]
})
export class AccountTaxDialogComponent implements OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  accountMappingsForm = new UntypedFormGroup({});
  taxMappingsForm = new UntypedFormGroup({});
  @ViewChild('stepper', { static: true }) stepper: MatStepper;

  constructor(
    public dialogRef: MatDialogRef<AccountTaxDialogComponent>,
    private xeroService: XeroService
  ) {}

  submit() {
    if (this.stepper.selectedIndex === 0) {
      this.saveAccountMappings();
      return;
    }
    this.saveTaxMappings();
  }

  saveAccountMappings() {
    this.xeroService
      .saveConfiguredAccounts(this.accountMappingsForm.value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response) => {
        this.stepper.selectedIndex = 1;
      });
  }

  saveTaxMappings() {
    const config = Object.keys(this.taxMappingsForm.value).map((key) => {
      return this.taxMappingsForm.value[key];
    });
    this.xeroService.saveXeroTaxRatesConfig({ config }).subscribe((result) => {
      this.dialogRef.close();
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
